import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import DeliveryCarrierLogo from './DeliveryCarrierLogo';
import { parseDeliveryOfferCarrier } from '../utils/deliveryOfferMessage';
import type { DeliveryPricingResponse } from '../utils/deliveryPricing';

type Props = {
  content: string;
  outgoing?: boolean;
  pricing?: DeliveryPricingResponse | null;
  locationProviderId?: number;
};

export default function DeliveryOfferMessageBody({
  content,
  outgoing = false,
  pricing,
  locationProviderId,
}: Props) {
  const carrier = parseDeliveryOfferCarrier(content);
  const titleColor = outgoing ? 'rgba(255,255,255,0.98)' : 'text.primary';

  return (
    <Stack spacing={1.25} sx={{ maxWidth: 280 }}>
      {carrier ? (
        <Box
          sx={{
            alignSelf: 'flex-start',
            bgcolor: '#fff',
            borderRadius: 1.25,
            px: 1.25,
            py: 0.75,
            border: '1px solid',
            borderColor: outgoing ? 'rgba(255,255,255,0.2)' : 'divider',
          }}
        >
          <DeliveryCarrierLogo
            carrier={carrier}
            height={30}
            maxWidth={112}
            pricing={pricing}
            locationProviderId={locationProviderId}
          />
        </Box>
      ) : null}
      <Typography variant="subtitle2" sx={{ fontWeight: 800, lineHeight: 1.35, color: titleColor }}>
        Proposition de livraison envoyée au propriétaire de l&apos;objet
      </Typography>
    </Stack>
  );
}
